import Footer from "../../components/Footer";
import Navbar from "../../components/Navbar";
import TextImageSection from "../Home/component/TextImageSection";
import ContactPageImage from "../../assets/Images/Home/ContactPage.jpg";
import { address, contactUs, genaral_support, mailBox } from "../LandingPage/components/SvgIcon";
import { useState } from "react";
import DropDown from "../../components/Dropdown";

export const ContactPage = () => {
  const [formData, setFormData] = useState({
    category:"",
    email: "",
    mobileNumber: "",
    title: "",
    query: ""
  });

  const [category,setCategory] = useState('');
  const options =['Feedback','Suggestion','Report a bug','Query','Complaint']

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Data Submitted:", formData);
  };
  return (
    <>
      <Navbar />
      <div className="home-section flex items-center">
        <TextImageSection
          view={"heading-then-image"}
          image={ContactPageImage}
          heading={"Our team is ready to assist you."}
          custumeClass="center-section leading-partner image-hr-text insta-loan credit-tool-instaloan loan-product-page blogs-page"
        ></TextImageSection>
        <div className="contact-us-combo">
          <div className="contact-us-card">
            <h1 className="contact-us-heading">Phone Number</h1>
            <div className="contact-card">
              <a href="tel:+91 884488448844">
                <span className="icon-contact-card">{contactUs}</span>
                <span className="icon-contact-info">+91 884488448844</span>
              </a>
            </div>
          </div>
          <div className="contact-us-card">
            <h1 className="contact-us-heading">Mail id</h1>
            <div className="contact-card">
              <a href="mailto:Care@fastfin.com" target="_blank" rel="noreferrer">
                <span className="icon-contact-card">{mailBox}</span>
                <span className="icon-contact-info">Care@fastfin.com</span>
              </a>
            </div>
          </div>
          <div className="contact-us-card">
            <h1 className="contact-us-heading">Address</h1>
            <div className="contact-card">
              <p>
                <span className="icon-contact-card">{address}</span>
                <span className="icon-contact-info">
                  Pencil Point Designs, Nariman <br />
                  point, near SBI office, Mumbai
                </span>
              </p>
            </div>
          </div>
        </div>
        <p className="contact-us-timing">
          Timings: Monday to Saturday - 9 am to 6 pm - Excluding public holidays
        </p>
      </div>
      <div className="contact-us">
        <div className="heading-contact">
          <p>Contact Us</p>
        </div>

        <div className="contact-form">
          <div className="form-container contact-us-form">
            <form className="form" onSubmit={handleSubmit}>
            <h3 className="form_heading">{genaral_support} General Support</h3>
              <div className="form-group">
                <DropDown
                  options={options}
                  title="Select Category"
                  name='category'
                  value={category}
                  onSelect={(data) => {setFormData({ ...formData, category: data });setCategory(data)}}
                />
              </div>

              <div className="form-group">
         
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Email *"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
              <input
                  type="tel"
                  id="mobileNumber"
                  name="mobileNumber"
                  placeholder="Number *"
                  value={formData.mobileNumber}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <input
                  type="text"
                  id="title"
                  name="title"
                  placeholder="Title *"
                  value={formData.loanType}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <textarea
                  id="Query"
                  name="query"
                  placeholder="Query *"
                  value={formData.description}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>

              <button type="submit" className="submit-button-form">
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
      <Footer custumeClass="landing-page-footer !bg-inherit !border-0" />
    </>
  );
};
